<div class="sso-employee-loader">

</div>

<h1 style="background-color: aliceblue;">Please Wait ...</h1>
